import { render, staticRenderFns } from "./disposal.vue?vue&type=template&id=55bda931&scoped=true"
import script from "./disposal.vue?vue&type=script&lang=js"
export * from "./disposal.vue?vue&type=script&lang=js"
import style0 from "./disposal.vue?vue&type=style&index=0&id=55bda931&prod&lang=less&scoped=true"
import style1 from "./disposal.vue?vue&type=style&index=1&id=55bda931&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bda931",
  null
  
)

export default component.exports